import { HANDLE_JOB_CARD_SITE_SERVICE, RESET } from '../actions';

const initialState = {  
    customerName: "",
    phone: [""],
    area: "",
    city: "",
    state: "",
    landmark: "",
    addressType: "",
    pincode: "",
    latitude: 11.3806,
    longitude: 77.8944,
    longitudeDelta: 0.015,
    latitudeDelta: 0.0121,
    addressString: "",
    scrollMap: false,
    fetchLocation: true,
    natureofProblem: "",
    work_type: "",
    servicePerson: "",
    jobCard: [],
    jobcard_number: "",
    edit: false,
    view: false,
    id: "",

    searchText: "",
    startDate: null,
    endDate: null,
    field: "14",
    status: [4],
    verificationstatus: 1,
    customerSearchText: "",
    selectedCustomer: null,
    customerData: [],
    filterApplied: true,

    toggleTable: true,
    products: [],

    dateFilter: "",
    workTypeFilter: [1,2,8],
    customer: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case HANDLE_JOB_CARD_SITE_SERVICE:
      return {
        ...state,
        ...action.data
      };
    case RESET:
        return initialState;
    default:
      return state;
  } 
}
